interface RecipientCardProps {
  fullName: string;
  username: string | null;
  avatarUrl: string | null;
  className?: string;
}

export default function RecipientCard({
  fullName,
  username,
  avatarUrl,
  className = "",
}: RecipientCardProps) {
  const truncatedName =
    fullName.length > 21 ? fullName.slice(0, 18) + "..." : fullName;
  return (
    <div className={`w-full rounded-xl bg-gray-4 border border-white/[0.04] p-3 flex items-center ${className}`}>
      <div className="bg-white/08 w-9 h-9 rounded-md p-px overflow-hidden mr-2.5 shrink-0">
        <img
          className="w-full h-full object-cover rounded-[5px]"
          src={avatarUrl || "images/default/user.svg"}
          alt="User Avatar"
        />
      </div>
      <div className="flex flex-col gap-0.5 min-w-0 flex-1">
        <p className="text-sm font-semibold leading-4 text-white truncate">
          {truncatedName || "Anonymous"}
        </p>
        {username && (
          <p className="text-xs font-normal leading-130 text-gray-1 truncate">
            @{username}
          </p>
        )}
      </div>
    </div>
  );
}
